const returnFocusTargets = new WeakMap();
let controller;

function isHiddenByStyle(element) {
  let current = element;
  while (current instanceof HTMLElement) {
    const style = window.getComputedStyle(current);
    if (style.display === "none" || style.visibility === "hidden") {
      return true;
    }
    current = current.parentElement;
  }
  return false;
}

function isVisibleFocusTarget(element) {
  if (!(element instanceof HTMLElement) || !element.isConnected) {
    return false;
  }

  return !isHiddenByStyle(element);
}

function resolveReturnFocusTarget(opener) {
  if (!(opener instanceof HTMLElement) || !opener.isConnected) {
    return null;
  }

  if (isVisibleFocusTarget(opener)) {
    return opener;
  }

  const dropdown = opener.closest(".dropdown, .dropup");
  if (dropdown) {
    const toggle = dropdown.querySelector(".dropdown-toggle");
    if (toggle instanceof HTMLElement && isVisibleFocusTarget(toggle)) {
      return toggle;
    }
  }

  return null;
}

export default function installModalAriaBridge() {
  controller?.abort();
  controller = new AbortController();
  const options = { signal: controller.signal };

  document.addEventListener(
    "show.bs.modal",
    (event) => {
      const modal = event.target.closest?.(".modal");
      if (!modal) {
        return;
      }
      const relatedTarget = event.relatedTarget;
      const activeElement = document.activeElement;
      const opener =
        relatedTarget instanceof HTMLElement
          ? relatedTarget
          : activeElement instanceof HTMLElement && activeElement !== document.body
            ? activeElement
            : null;

      if (opener) {
        returnFocusTargets.set(modal, opener);
      }
      modal.setAttribute("aria-hidden", "false");
      modal.setAttribute("tabindex", "-1");
    },
    options,
  );

  document.addEventListener(
    "shown.bs.modal",
    (event) => {
      const modal = event.target.closest?.(".modal");
      if (modal && !modal.contains(document.activeElement)) {
        modal.focus();
      }
    },
    options,
  );

  document.addEventListener(
    "hidden.bs.modal",
    (event) => {
      const modal = event.target.closest?.(".modal");
      if (!modal) {
        return;
      }
      modal.setAttribute("aria-hidden", "true");
      const returnFocusTarget = resolveReturnFocusTarget(returnFocusTargets.get(modal));
      if (returnFocusTarget) {
        returnFocusTarget.focus();
      }
      returnFocusTargets.delete(modal);
    },
    options,
  );
}
